import { Injectable } from '@angular/core';
import { BaseStyle } from 'primeng/base';

interface ChartStyleContext {
  instance: {
    width: number;
    height: number;
  };
}

const inlineStyles = {
  root: ({ instance }: ChartStyleContext) => ({
    display: 'block',
    position: 'relative',
    width: instance.width,
    height: instance.height
  })
};

const classes = {
    root: 'p-chart'
};

@Injectable()
export class ChartStyle extends BaseStyle {
    override name = 'chart';

    override classes = classes;

    override inlineStyles = inlineStyles;
}

/**
 *
 * Chart groups a collection of contents in tabs.
 *
 * [Live Demo](https://www.primeng.org/chart/)
 *
 * @module chartstyle
 *
 */
export enum ChartClasses {
    /**
     * Class name of the root element
     */
    root = 'p-chart'
}

export interface ChartStyle extends BaseStyle {}
